// src/components/Product-zone/Directory/TraderCard.jsx
import React from "react";
import { Heart, UserPlus, Award, CheckCircle } from "lucide-react";

export default function TraderCard({ trader }) {
  return (
    <div className="group flex flex-col items-center rounded-2xl border border-white/5 bg-gradient-to-b from-[#0E1325] to-[#0A0F1F] p-3 text-center shadow-md transition-all duration-300 hover:border-blue-500/40 hover:shadow-blue-500/20">
      {/* Avatar */}
      <div className="relative">
        <img
          src={trader.photo}
          alt={trader.name}
          className="h-20 w-20 rounded-xl border border-blue-500/40 object-cover shadow-md transition group-hover:shadow-blue-500/40"
        />

        {/* Online / Offline */}
        <span
          className={`absolute bottom-1 right-1 h-2.5 w-2.5 rounded-full border border-[#0A0F1F] ${
            trader.status === "online" ? "bg-green-400" : "bg-gray-500"
          }`}
        />
      </div>

      {/* Name */}
      <h3 className="mt-3 truncate text-sm font-semibold text-white">
        {trader.name}
      </h3>

      {/* Role */}
      <p className="text-[11px] text-blue-400">{trader.category}</p>
      <p className="text-[10px] text-slate-400">{trader.country}</p>

      {/* Badges */}
      <div className="mt-2 flex flex-wrap justify-center gap-1">
        {trader.badges.map((badge, idx) => (
          <span
            key={idx}
            className="flex items-center gap-1 rounded-full border border-blue-500/20 bg-blue-500/10 px-2 py-[2px] text-[9px] text-blue-300"
          >
            {badge === "Verified" ? (
              <CheckCircle className="h-3 w-3 text-green-400" />
            ) : (
              <Award className="h-3 w-3 text-yellow-400" />
            )}
            {badge}
          </span>
        ))}
      </div>

      {/* Stats */}
      <div className="mt-3 flex w-full items-center justify-between px-2 text-[11px] text-slate-400">
        <div className="flex items-center gap-1">
          <Heart className="h-4 w-4 text-pink-400" />
          {trader.likes}
        </div>
        <div className="flex items-center gap-1">
          <UserPlus className="h-4 w-4 text-blue-400" />
          {trader.followers}
        </div>
      </div>

      {/* CTA */}
      <button className="mt-3 w-full rounded-full bg-gradient-to-r from-blue-500 to-purple-600 py-1.5 text-xs font-medium text-white transition hover:from-blue-600 hover:to-purple-700">
        Follow
      </button>
    </div>
  );
}
